import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
export class UIDLoadingScreen {
    showBackground() {
        this.setAnimationInitialState();
    }
    hideBackground() {
        this.setAnimationFinalState();
    }
    hideSpinner() {
        this.loadingSpinner.style.visibility = 'hidden';
    }
    showSpinner() {
        this.loadingSpinner.style.visibility = 'visible';
    }
    setAnimationInitialState() {
        this.loadingContainer.style.display = 'inherit';
        this.loadingContainer.style.visibility = 'visible';
        this.loadingContainer.style.opacity = '1';
    }
    setAnimationFinalState() {
        this.loadingContainer.style.opacity = '0';
        this.loadingContainer.style.visibility = 'hidden';
        this.hideDisplayAfterAnimationComplete();
    }
    hideDisplayAfterAnimationComplete() {
        const animationCompletionDelay = 1000 // Milliseconds
        ;
        setTimeout(()=>{
            this.loadingContainer.style.display = 'none';
        }, animationCompletionDelay);
    }
    constructor(){
        if (!UIUtilsEjsVariables.isUserOnDiscord) return;
        this.loadingContainer = document.getElementById('loading-screen');
        this.loadingSpinner = document.getElementById('loading-screen-spinner-container');
    }
}
